import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import addCommas from '../../utils/functions/commas';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import EventIcon from '@mui/icons-material/Event';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import { styled } from '@mui/material/styles'; // 1. ต้อง import 'styled'
import SortableTableLabel from '../../components/Table/SortableTableLabel';


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
  
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },
  transition: 'transform 0.15s ',
}));

function SearchCustomerAndTable({ t }) {
  const [data, setData] = useState([]);
  const [searchTotal, setSearchTotal] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [sortBy, setSortBy] = useState('invoice_no');
  const [sortOrder, setSortOrder] = useState('asc');
  const [startDate, setStartDate] = useState(dayjs().format('YYYY-MM'));

  const startIndex = rowsPerPage * page;
  const endIndex = startIndex + rowsPerPage;

  const filteredData = data.filter((row) => {
    // กรองโดยใช้เงื่อนไขทั้งสอง โดยต้องค้นหาจาก searchText หรือ searchUpload
    return (
      row?.customer_id?.toLowerCase().includes(searchCustomer.toLowerCase()) &&
      row?.total_amount
        .toString()
        .toLowerCase()
        .includes(searchTotal.toLowerCase())
    );
  });

  const sortedData = [...filteredData].sort((left, right) => {
    const comparison = String(left[sortBy] ?? '').localeCompare(
      String(right[sortBy] ?? ''),
      undefined,
      { numeric: true, sensitivity: 'base' },
    );
    return sortOrder === 'asc' ? comparison : -comparison;
  });
  const slicedData = sortedData.slice(startIndex, endIndex);
  const columns = [
    { id: 'invoice_no', label: t('app.invoiceNo') },
    { id: 'customer_id', label: t('app.customerID') },
    { id: 'CustomerName', label: t('app.customerName') },
    { id: 'total_amount', label: t('app.totalThb') },
    { id: 'start_date', label: t('app.startDate') },
    { id: 'due_date', label: t('app.endDate') },
  ];

  const handleSearchCustomer = (event) => {
    setSearchCustomer(event.target.value);
  };
  const handleSearchTotal = (event) => {
    setSearchTotal(event.target.value);
  };

  const handleStartDateChange = (event) => {
    const selectDate = event.target.value;
    setStartDate(selectDate);
    fetchApprovedData(selectDate);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0); // ตั้งค่าหน้าเริ่มต้นเป็นหน้าที่ 0 เมื่อเปลี่ยนแถวต่อหน้า
  };
  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };

  const fetchApprovedData = async (startDate) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/matchstatement/all-unpaid-invoice`,
        {
          start_date: startDate,
        },
      );
      const data = response.data;

      console.log('ข้อมูลที่ได้รับจาก API:', data);

      setData(data?.data); // เปลี่ยน responseData เป็น data
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchApprovedData(startDate);
  }, [startDate]);

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: '#4caf50', // ใช้โทน MUI primary
    color: 'white',
    padding: '12px',
    fontWeight: 'bold',
    fontSize: '13px',
  };

  const customCellData = {
    whiteSpace: 'nowrap',
    fontSize: '12px',
    padding: '10px',
    borderBottom: '1px solid #e0e0e0',
  };

  const handleExport = () => {
    const customData = slicedData.map((row) => ({
      InvoiceNo: row.invoice_no,
      CustomerID: row.customer_id,
      CustomerName: row.CustomerName,
      Total: row.total_amount,
      StartDate: row.start_date,
      EndDate: row.due_date,
    }));

    const ws = XLSX.utils.json_to_sheet(customData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ReportUnMatch');
    XLSX.writeFile(wb, 'ReportUnMatch.xlsx');
  };

  return (
    <div className="">
      <div className="border-2 border-gray-300 xl:h-[300px]  p-5 ">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
          <div className="">
            {' '}
            {t('app.customerNameTaxID')}
            <div>
              <TextField
                value={searchCustomer}
                onChange={handleSearchCustomer}
                sx={{ width: '100%' }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
                className='"app-search-input'
                type="text"
                placeholder="Search Customer Name / Tax ID"
                id="outlined-basic"
                size="small"
              />
            </div>
          </div>
          <div className="">
            {t('app.amountMoneyThb')}
            <div className="">
              <TextField
                value={searchTotal}
                sx={{ width: '100%' }}
                onChange={handleSearchTotal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MonetizationOnIcon />
                    </InputAdornment>
                  ),
                }}
                className='"app-search-input'
                type="text"
                placeholder={t('app.thb')}
                id="outlined-basic"
                size="small"
              />
            </div>
          </div>

          <div className=" ">
            {' '}
            {t('app.startDate')}
            <div className="">
              <TextField
                type="month"
                id="outlined-basic"
                variant="outlined"
                sx={{ width: '100%' }}
                size="small"
                value={startDate}
                onChange={handleStartDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </div>

        <div className="mt-2 flex justify-end">
          <Button
            variant="contained"
            sx={{ color: 'white' }}
            onClick={handleExport}
          >
            <FileDownloadIcon /> {t('app.export')}
          </Button>
        </div>
      </div>
      <div className="mt-5 border-2">
        <div>
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align="center" sx={customCellHeader}>
                      <SortableTableLabel
                        column={column}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        onSort={handleRequestSort}
                        color="white"
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {_.size(data) ? (
                <TableBody>
                  {slicedData.map((row, index) => (
                    <StyledTableRow
                      key={index}
                    >
                      <TableCell sx={customCellData}>
                        <div className="text-green-600 font-bold">
                          {row.invoice_no}
                        </div>
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.customer_id}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.CustomerName ? row.CustomerName : '-'}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {addCommas(row.total_amount)}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.start_date
                          ? dayjs(row.start_date).format('DD MMM YYYY')
                          : '-'}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.due_date
                          ? dayjs(row.due_date).format('DD MMM YYYY')
                          : '-'}
                      </TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div>{t('app.noDataAvailable')}</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data?.length} // ใช้ค่า 'total' แทน
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage} // จัดตำแหน่ง pagination ไปทางขวา
          />
        </div>
      </div>
    </div>
  );
}

export default SearchCustomerAndTable;
